import React from 'react';
import { Outlet } from 'react-router-dom';
import { LayoutProvider } from './LayoutContext';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import './AppLayout.css';

export function AppLayout() {
  return (
    <LayoutProvider>
      <div className="app-shell">
        <Sidebar />
        <div className="app-main">
          <TopBar />
          <main className="app-content">
            <Outlet />
          </main>
        </div>
      </div>
    </LayoutProvider>
  );
}
